<template>
  <div class="mt-4 px-5">
    <v-alert dense text shaped type="info">
      <b>Soll-/Ist-Auswertung</b>
      <div>
        Hier sehen Sie die Übersicht der Arbeitsstunden pro Mitglied für das ausgewählte Jahr.
      </div>
    </v-alert>

    <v-card class="mb-4">
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" sm="4">
            <v-select
              v-model="selectedYear"
              :items="years"
              label="Jahr"
              hide-details
              @change="fetchData"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4">
            <v-switch
              v-model="onlyConfirmed"
              label="Nur bestätigte Einträge"
              hide-details
              @change="fetchData"
            ></v-switch>
          </v-col>
          <v-col cols="12" sm="4" class="text-right d-flex align-center justify-end">
            <working-hours-evaluation-excel-export
                v-if="$store.state.ClubApp.ArbeitsstundenAuswertung && $store.state.ClubApp.ArbeitsstundenAuswertung.length > 0"
                :excel_data="$store.state.ClubApp.ArbeitsstundenAuswertung"
                :name="$store.getters['ClubAuth/isClubName']"
                :year="selectedYear"
            ></working-hours-evaluation-excel-export>
            <v-btn icon color="primary" @click="fetchData">
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="$store.state.ClubApp.ArbeitsstundenAuswertung"
      :loading="loading"
      sort-by="name"
      class="elevation-1"
      no-data-text="Keine Daten für diesen Zeitraum vorhanden."
      loading-text="Daten werden geladen..."
    >
      <template v-slot:item.erfuellt="{ item }">
        <v-chip
          :color="item.erfuellt ? 'success' : 'error'"
          dark
          small
        >
          {{ item.erfuellt ? 'Erfüllt' : 'Offen' }}
        </v-chip>
      </template>
      <template v-slot:item.ist_stunden="{ item }">
        {{ item.ist_stunden.toFixed(2) }} h
      </template>
      <template v-slot:item.soll_stunden="{ item }">
        {{ item.soll_stunden.toFixed(2) }} h
      </template>
      <template v-slot:item.differenz="{ item }">
        <span :class="item.differenz >= 0 ? 'success--text' : 'error--text'">
          {{ item.differenz.toFixed(2) }} h
        </span>
      </template>
      <template v-slot:item.anzahl_eintraege="{ item }">
        <v-btn
            small
            text
            color="primary"
            @click="jumpToWorkingHours(item)"
            v-if="item.anzahl_eintraege > 0 && $store.getters['ClubAuth/clubCan'].arbeitsstunden"
        >
          {{ item.anzahl_eintraege }}
          <v-icon right x-small>mdi-open-in-new</v-icon>
        </v-btn>
        <span v-else>{{ item.anzahl_eintraege }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import WorkingHoursEvaluationExcelExport from "@/views/component/WorkingHoursEvaluationExcelExport.vue";

export default {
  name: "WorkinghoursEvaluation",
  components: {WorkingHoursEvaluationExcelExport},
  data() {
    return {
      loading: false,
      selectedYear: new Date().getFullYear(),
      onlyConfirmed: true,
      years: [],
      headers: [
        { text: "Mitgliedsnummer", value: "mitgliedsnummer" },
        { text: "Nachname", value: "name" },
        { text: "Vorname", value: "vorname" },
        { text: "Beitragsgruppe", value: "beitragsgruppe.name" },
        { text: "Soll", value: "soll_stunden" },
        { text: "Ist", value: "ist_stunden" },
        { text: "Differenz", value: "differenz" },
        { text: "Status", value: "erfuellt", sortable: false },
        { text: "Einträge", value: "anzahl_eintraege" },
      ],
    };
  },
  mounted() {
    this.initYears();
    this.fetchData();
  },
  methods: {
    initYears() {
      const currentYear = new Date().getFullYear();
      for (let i = currentYear; i >= currentYear - 5; i--) {
        this.years.push(i);
      }
    },
    async fetchData() {
      this.loading = true;
      try {
        await this.$store.dispatch("ClubApp/getArbeitsstundenAuswertung", {
          Year: this.selectedYear,
          nur_bestaetigt: this.onlyConfirmed ? 1 : 0,
        });
      } catch (error) {
        console.error("Fehler beim Laden der Auswertung:", error);
      } finally {
        this.loading = false;
      }
    },
    jumpToWorkingHours(item) {
      this.$router.push({
        path: '/club/arbeitsstunden',
        query: {
          search: item.name,
          year: this.selectedYear
        }
      });
    },
  },
};
</script>
